import { useEffect } from "react";
import { toast } from "react-toastify";
import socket from "../socket";

function ClientSocketListener({ scannedProducts, user, onProductUpdate }) {
  useEffect(() => {
    console.log("🟢 Listener monté avec produits :", scannedProducts);

    if (!user || user.subscribedToPush === false) {
      console.log("🔕 Notifications désactivées pour cet utilisateur");
      return;
    }

    // 🔄 petit délai pour être sûr que ToastContainer est prêt
    const initTimeout = setTimeout(() => {
      if (scannedProducts && scannedProducts.length > 0) {
        scannedProducts.forEach((product) => {
          const room = `product-${product.productId}`;
          socket.emit("subscribeToProduct", product.productId);
          console.log(`📶 Demande d'abonnement envoyée pour ${room}`);
        });
      }

      socket.on("productUpdated", (updatedProduct) => {
        console.log("📡 Nouveau statut reçu :", updatedProduct);

        // ✅ Vérifie que le toast container est monté
        requestAnimationFrame(() => {
          toast.info(
            `🔔 Le produit ${updatedProduct.articleName} a changé de statut : ${updatedProduct.status}`,
            {
              position: "top-right",
              autoClose: 5000,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        });

        if (typeof onProductUpdate === "function") {
          onProductUpdate(updatedProduct);
        }
      });
    }, 500); // ← 500 ms suffit à laisser le temps au ToastContainer d’être dispo

    return () => {
      clearTimeout(initTimeout);
      socket.off("productUpdated");
    };
  }, [scannedProducts, user]);

  return null;
}

export default ClientSocketListener;
